function initReadMore() {
  const desc = document.querySelector(".collection-hero__description");
  if (!desc) return;

  // Avoid duplicating the button on repeated loads
  if (desc.nextElementSibling?.classList?.contains("read-more-btn")) return;

  const readMoreBtn = document.createElement("span");
  readMoreBtn.className = "read-more-btn";
  readMoreBtn.innerHTML = `
    <span class="text">READ MORE</span>
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 2.5V5M5 7.5V5M5 5H2.5M5 5H7.5M0.5 0.5H9.5V9.5H0.5V0.5Z" stroke="currentColor"/>
    </svg>
  `;

  const textEl = readMoreBtn.querySelector(".text");
  const iconEl = readMoreBtn.querySelector(".icon");

  // Only add the button if text is long enough (using line-clamp height estimate)
  desc.classList.add("check-height");
  const collapsedHeight = desc.getBoundingClientRect().height;
  desc.classList.remove("check-height");
  const fullHeight = desc.scrollHeight;

  if (fullHeight > collapsedHeight + 10) {
    desc.insertAdjacentElement("afterend", readMoreBtn);
  }

  let isExpanded = false;
  readMoreBtn.addEventListener("click", function () {
    isExpanded = !isExpanded;
    desc.classList.toggle("expanded", isExpanded);
    textEl.textContent = isExpanded ? "READ LESS" : "READ MORE";
    iconEl.classList.toggle("rotated", isExpanded);
  });
}

// Use MutationObserver to wait for .collection-hero__description to load
const observer = new MutationObserver(() => {
  const desc = document.querySelector(".collection-hero__description");
  if (desc) {
    initReadMore();
    observer.disconnect(); // Stop watching after adding the button
  }
});

observer.observe(document.body, { childList: true, subtree: true });

// Also try to run on DOM ready just in case it's already there
document.addEventListener("DOMContentLoaded", initReadMore);
